module.exports = __webpack_public_path__ + "img/202307_09.368ef26d.jpg";